"use client"

import * as React from "react"
import Link from "next/link"
import { RotateCcw, TriangleAlert } from "lucide-react"

import { Button } from "@/components/ui/button"

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  React.useEffect(() => {
    console.error("[app] unhandled error", error)
  }, [error])

  return (
    <div className="container-page flex min-h-[64svh] flex-col items-center justify-center py-20 text-center">
      <span className="grid size-14 place-items-center rounded-[var(--radius-lg)] bg-danger-500/10 text-danger-500">
        <TriangleAlert className="size-7" aria-hidden />
      </span>

      <h1 className="mt-7 text-[clamp(1.25rem,3vw,1.75rem)] font-extrabold text-[var(--content)]">
        خطایی رخ داد
      </h1>
      <p className="mt-3 max-w-md text-pretty text-[0.9375rem] leading-[var(--leading-relaxed)] text-[var(--content-muted)]">
        مشکلی در بارگذاری این بخش پیش آمد. یک‌بار دیگر تلاش کنید؛ اگر تکرار شد، با پشتیبانی تماس
        بگیرید.
      </p>

      {error.digest ? (
        <p className="ltr-nums mt-4 rounded-[var(--radius-sm)] bg-[var(--canvas-subtle)] px-3 py-1.5 font-mono text-[0.6875rem] text-[var(--content-subtle)]">
          کد پیگیری: {error.digest}
        </p>
      ) : null}

      <div className="mt-8 flex flex-wrap justify-center gap-3">
        <Button size="lg" onClick={reset}>
          <RotateCcw aria-hidden />
          تلاش دوباره
        </Button>
        <Button asChild variant="secondary" size="lg">
          <Link href="/">بازگشت به صفحه اصلی</Link>
        </Button>
      </div>
    </div>
  )
}
